import { Product, ProductVariant } from "../types/api";

export const SALE_TAG = "sale";

/** A variant is on sale when it carries a previous price above its retail price. */
export const isVariantOnSale = (v: ProductVariant | undefined | null): boolean =>
  !!v && (v.previousPrice || 0) > (v.retailPrice || 0);

/** Variants still part of the product (ignores ones marked for deletion in the editor). */
const liveVariants = (product: Product): ProductVariant[] =>
  (product.variants || []).filter((v: any) => v.pendingDelete !== true);

export const anyVariantOnSale = (product: Product): boolean =>
  liveVariants(product).some(isVariantOnSale);

/**
 * Ends the sale on one variant: the retail price goes back to the previous
 * price and the previous price is cleared. Mutates the variant. No-op when
 * the variant is not on sale.
 */
export const endSaleOnVariant = (v: ProductVariant): void => {
  if (!isVariantOnSale(v)) return;
  v.retailPrice = v.previousPrice as number;
  v.previousPrice = null as any;
};

/**
 * Keeps the product's `sale` tag honest: present if ANY live variant is on
 * sale, absent if none are. Mutates the product's tags array in place (the
 * editor works on a single mutable product object) and returns the product.
 * This is the one rule for the tag; every path that changes prices uses it.
 */
export const syncSaleTag = (product: Product): Product => {
  if (!product.tags) product.tags = [];
  const idx = product.tags.indexOf(SALE_TAG);
  if (anyVariantOnSale(product)) {
    if (idx === -1) product.tags.push(SALE_TAG);
  } else if (idx !== -1) {
    product.tags.splice(idx, 1);
  }
  return product;
};
